var BFFGatewayConfiguration = /** @class */ (function () {
    function BFFGatewayConfiguration(param) {
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
    return BFFGatewayConfiguration;
}());
export { BFFGatewayConfiguration };
//# sourceMappingURL=BFFGatewayConfiguration.js.map